<template>
    <div>
        <div class="module-body">
            <form role="form" method="POST" @submit.prevent="doSubmit">
                <h5 class="form__subtitle">{{ $t('words.password_change') }}</h5>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="email">{{ $t('words.old_password') }}</label>
                    <div class="col-md-9">
                        <input type="password" class="form-control" id="old_password" autocomplete="false" :class="{'form-control':true, 'is-invalid':meta.errors.old_password}" v-model="old_password">
                        <span class="invalid-feedback" v-if="meta.errors.old_password" v-for="error in meta.errors.old_password" :key="error">{{ error }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="name">{{ $t('words.new_password') }}</label>
                    <div class="col-md-9">
                        <input type="password" class="form-control" id="new_password" autocomplete="false" :class="{'form-control':true, 'is-invalid':meta.errors.new_password}" v-model="new_password">
                        <span class="invalid-feedback" v-if="meta.errors.new_password" v-for="error in meta.errors.new_password" :key="error">{{ error }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="role">{{ $t('words.password_confirm') }}</label>
                    <div class="col-md-9">
                        <input type="password" class="form-control" id="password_confirm" autocomplete="false" :class="{'form-control':true, 'is-invalid':meta.errors.password_confirm}" v-model="password_confirm">
                        <span class="invalid-feedback" v-if="meta.errors.password_confirm" v-for="error in meta.errors.password_confirm" :key="error">{{ error }}</span>
                    </div>
                </div>
            </form>
        </div>
        <div class="module-footer">
            <button type="submit" class="btn btn-lg btn-primary" v-if="haveSubmitRight" @click.prevent="doSubmit">
                {{ $t('words.save') }}
            </button>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
    },
    data() {
        return {
            old_password: '',
            new_password: '',
            password_confirm: '',
            meta: {
                errors: {},
            },
        };
    },
    mounted() {
    },
    methods: {
        doSubmit() {
            const confirmMessage = this.$t('paragraphs.message.confirm.update_item');
            if (confirm(confirmMessage)) {
                axios.put('/cms/account/password', {
                    old_password: this.old_password,
                    new_password: this.new_password,
                    password_confirm: this.password_confirm,
                }).then(() => {
                    this.$toasted.success(this.$t('paragraphs.message.success.update'));

                    location.reload();
                }).catch((error) => {
                    this.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.update'));
                });
            }
        },
    },
    computed: {
        haveSubmitRight() {
            return this.haveOwnerRight;
        },
    },
    watch: {
    },
};
</script>

<style scoped>

</style>
